import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import BillingOverviewPage from '@pages/billingOverview/BillingOverviewPage';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

// const Shifts = lazy(() => import('@pages/Shifts').then((m) => ({ default: m.Shifts })));

// const BillingOverviewPage = lazy(() => import('@pages/billingOverview/BillingOverviewPage'));

// Route Component
const BillingOverviewRoute = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('billing-overview-page-title')}>
        <BillingOverviewPage />
      </PageWrapper>
    </Suspense>
  );
};

// Export Lazy-Loaded Route
export default {
  BillingOverviewRoute,
};
